// Motyw wyglądu: ustawia atrybut `data-theme` na <html> (kolor głównego przycisku ekranu startowego jest w styles.css) oraz kolor paska przeglądarki na telefonie.
// Motyw to grupa awatara (Dinozaury / Pokémon / Neutralne) — wybór awatara ustawia go automatycznie (zob. lookPicker.ts).
import { THEMES, isTheme } from '../lib/look.ts';
import type { Look, ThemeId } from '../lib/look.ts';

/** Kolor paska przeglądarki (meta theme-color) dla każdego motywu. */
export const THEME_COLOR: Record<ThemeId, string> = {
  neutral: '#4f4cee',
  dino: '#49734c',
  pokemon: '#3d63dd',
};

interface DocLike {
  documentElement: { dataset: Record<string, string | undefined> };
  querySelector(selector: string): { setAttribute(name: string, value: string): void } | null;
}

export function applyLook(look: Pick<Look, 'theme'>, doc: DocLike = document as unknown as DocLike): void {
  const theme: ThemeId = isTheme(look.theme) ? look.theme : THEMES[0];
  doc.documentElement.dataset.theme = theme;
  doc.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[theme]);
}
